export const language: any = {
  title: "Hey! Cooker 커뮤니티",
  follow: "팔로우",
  follower: "팔로워",
  post_share: "공유 게시물",
  like_share: "좋아요",
  report: "위반 신고",
  delete_post: "게시물 삭제",
  delete_comment: "댓글 삭제",
  confirm_report: "이 게시물이 커뮤니티 가이드라인을 위반하는 내용을 포함하고 있다고 확신합니까? 신고가 성공하면 이 게시물을 더 이상 볼 수 없습니다.",
  confirm_report_comment: "이 댓글이 커뮤니티 가이드라인을 위반한다고 확신합니까?",
  toats_report: "위반 신고에 감사드립니다. 신고가 검토 중입니다.",
  confirm_delete: "이 게시물을 삭제하시겠습니까?",
  confirm_delete_comment: "이 댓글을 삭제하시겠습니까?",
  toast_delete: "삭제 완료했습니다!",
  text_yes: "예",
  text_no: "아니요",
  create: {
    title: "글 작성 - 헤이!쿠커 커뮤니티",
    content_placeholder: "게시물 내용을 입력하세요",
    submit: "바로 공유하기",
    add_image_by_camera: "카메라로 촬영하기",
    add_image_by_gallery: "사진 선택하기",
    add_video_by_camera: "비디오 촬영",
    add_video_by_gallery: "비디오 선택",
  },
  detail: {
    shared: "공유",
    shared_community: "사진(비디오)이/가 커뮤니티와 공유됨"
  },
  follwed: "팔로우함",
  comment: {
    placeholder: "내용을 입력해 주세요",
    submit: "보내기",
    nodata: "댓글을 남겨 첫 번째 댓글 작성자가 되어보세요!",
    load_more: "댓글 더보기",
    not_login: "댓글하기 위해 로그인해 주세요",
    delete: "댓글 삭제",
    delete_confirm: "이 댓글을 삭제할까요?",
    delete_success: "댓글을 삭제했습니다",
    report: "위반 신고",
    report_confirm: "이 댓글이 커뮤니티 가이드라인을 위반한다고 확신하나요?",
    report_success: "위반신고 해주셔서 감사합니다.\n신고 내용은 검토 중입니다",
  },
  bottom_navigation: "커뮤니티",
  shared_post: "게시물을 공유했습니다"
}
